<template>
  <Icon
    :id="`${name}-icon`"
    :name="`icons:${name}`"
    class="icon"
    mode="svg"
    :class="[sizeUnset ? 'icon--unset' : `icon--${size}`]"
  />
</template>

<script setup lang="ts">
type Props = {
  name: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  sizeUnset?: boolean
}

withDefaults(defineProps<Props>(), {
  size: 'md',
})
</script>

<style lang="scss">
.icon {
  display: inline-block;
  flex-shrink: 0;

  &--xs {
    width: 16px;
    height: 16px;
  }

  &--sm {
    width: 20px;
    height: 20px;
  }

  &--md {
    width: 24px;
    height: 24px;
  }

  &--lg {
    width: 32px;
    height: 32px;
  }

  &--xl {
    width: 48px;
    height: 48px;
  }

  &--unset {
    width: 100%;
    height: 100%;
  }
}
</style>
